import React, {useState} from 'react';
import {BookmarkAdd} from '@mui/icons-material';
import {CircularProgress} from '@mui/material';
import {toast} from 'react-toastify';
import {trackProduct} from '../../product/infrastructure/productApi';
import {isSuccess} from '../../common/domain/RemoteData.model';
import {useCartContext} from '../context/CartContext';
import {useComercialContext} from '../../comercial/ComercialContext';

/**
 * Botón para mover una línea del carrito sin stock suficiente a los
 * productos pendientes: guarda el pendiente con la cantidad deseada
 * y quita la línea del carrito.
 *
 * @param {{product: {code: string, quantity: number}, onDone?: () => void}} props
 */
export const AddToPendingButton = ({product, onDone}) => {
  const [loading, setLoading] = useState(false);
  const {removeProduct} = useCartContext();
  const {actingAsCliente} = useComercialContext();

  const handleClick = async () => {
    setLoading(true);
    try {
      const result = await trackProduct(product.code, product.quantity, actingAsCliente?.numCliente);
      if (!isSuccess(result)) {
        toast.error('Error al añadir el producto a tus productos pendientes');
        return;
      }
      await removeProduct(product);
      toast.success('Producto movido a pendientes. Te avisaremos cuando haya stock!');
      onDone?.();
    } catch (error) {
      console.error('Failed to move product to pending:', error);
      toast.error('Error al añadir el producto a tus productos pendientes');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button type="button"
      className="btn btn-warning d-flex align-items-center gap-1"
      onClick={handleClick}
      disabled={loading}>
      {loading ? <CircularProgress size={20}/> : <BookmarkAdd/>}
      Añadir a pendientes
    </button>
  );
};
